import { useAuth } from "./use-auth";
import { hasPermission, type PermissionAction } from "./permissions";

export function usePermission(module: string, action: PermissionAction): boolean {
	const { user } = useAuth();
	return hasPermission(user, module, action);
}
